import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Emits {
  (e: "submitForm", arg: Event): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  emits: ["submitForm"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const emitSubmitForm = (e: Event) => {
  emit("submitForm", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form-layout",
    novalidate: "",
    onSubmit: _withModifiers(emitSubmitForm, ["prevent"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}
}

})